<template>
    <tbody>
        <tr>
            <td>{{ name }}</td>
            <td>{{ currencyFormat(value) }}</td>
            <td>
                <div class="a-form-inputs">
                    <control before-after="pound" :table-control="true">
                        <input autocomplete="off" v-model="dependantsValue"
                        v-field-control
                        required
                        v-two-dp
                        type="number"
                        @input="updateTotals">
                    </control>
                </div>
            </td>
            <td>{{ currencyFormat(value - dependantsValue) }}</td>
            <td>{{ roundAndPercent(value, dependantsValue) }}%</td>
        </tr>
        <tr v-if="this.showInterest">
            <td>{{ name }} - Interest</td>
            <td>{{ currencyFormat(interestAccrued) }}</td>
            <td>
                <div class="a-form-inputs">
                    <control before-after="pound" :table-control="true">
                        <input autocomplete="off" v-model="dependantsInterestValue"
                               v-field-control
                               required
                               v-two-dp
                               type="number"
                               @input="updateTotals">
                    </control>
                </div>
            </td>
            <td>{{ currencyFormat(interestAccrued - dependantsInterestValue) }}</td>
            <td>{{ roundAndPercent(interestAccrued, dependantsInterestValue) }}%</td>
        </tr>
    </tbody>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import Vue from 'vue';
    import currencyFormat from 'mixins/currencyFormat';
    import Control from 'components/form/Control.vue';
    import percentageDifference from 'mixins/percentageDifference';
    import roundValue from 'mixins/roundValue';
    import TwoDecimalPlaces from 'directives/TwoDecimalPlaces';

    export default {
        name: 'custom-head-of-loss',
        props: ['index','headOfLoss', 'showInterest'],
        mixins: [
            currencyFormat,
            percentageDifference,
            roundValue
        ],
        components: {
            Control
        },
        directives: {
            'two-dp': TwoDecimalPlaces
        },
        computed: {
            ...mapGetters('documents', {
                getDocumentDataByKey: 'getDocumentDataByKey',
            }),
            name: {
                get() {
                    return this.headOfLoss.name;
                },
            },
            value: {
                get() {
                    return this.headOfLoss.value;
                },
            },
            interestAccrued: {
                get() {
                    return this.headOfLoss.interestAccrued;
                },
            },
            dependantsValue: {
                get() {
                    return this.getDocumentDataByKey({key: this.headOfLoss.name, index: this.index}) || 0;
                },
                set(value) {
                    this.updateDataByKey({key: this.name, value, index: this.index});
                }
            },
            dependantsInterestValue: {
                get() {
                    return this.getDocumentDataByKey({key: this.headOfLoss.name+'WithInterest', index: this.index}) || 0;
                },
                set(value) {
                    this.updateDataByKey({key: this.name+'WithInterest', value, index: this.index});
                }
            }
        },
        methods: {
            ...mapActions('documents', {
                updateDataByKey: 'updateDataByKey',
            }),
            roundAndPercent(val1, val2) {
                return this.roundValue(this.percentageDifference(val1, val2), 2);
            },
            updateTotals () {
                this.$emit('update');
            },
        }
    }
</script>


// WEBPACK FOOTER //
// CustomHeadOfLoss.vue?532b1112